<template>
  <div>
    <div class="container">
      <el-row class="item-class-group" v-if="menuIdx.length!==0">
        <el-col class="item-class-name" :span="2">分类:</el-col>
          <el-col class="item-class-select" :span="19">
            <!-- 一级 -->
            <span v-if="menuIdx.length>0&&menuIdx[0]>-1&& exportMenu[menuIdx[0]]" >
              <span class="item-class-spandx">
                {{exportMenu[menuIdx[0]].fieldName}}
                <i class="el-icon-close iconstyle" @click="chooseCategory([])"></i>
              </span>
            </span>
            <!-- 二级 -->
            <span v-if="menuIdx.length>1&&menuIdx[0]>-1&&menuIdx[1]>-1&&exportMenu[menuIdx[0]]&& exportMenu[menuIdx[0]].children&& exportMenu[menuIdx[0]].children[menuIdx[1]]" >
              <i class="el-icon-arrow-right"></i>
              <span class="item-class-spandx">{{exportMenu[menuIdx[0]].children[menuIdx[1]].fieldName}}
                <i class="el-icon-close iconstyle" @click="chooseCategory([menuIdx[0]])"></i>
              </span>
            </span>
            <!-- 三级 -->
            <span v-if="menuIdx.length>2&&menuIdx[0]>-1&&menuIdx[1]>-1&&menuIdx[2]>-1&&exportMenu[menuIdx[0]]&& exportMenu[menuIdx[0]].children&& exportMenu[menuIdx[0]].children[menuIdx[1]]&& exportMenu[menuIdx[0]].children[menuIdx[1]].children[menuIdx[2]]" >
              <i class="el-icon-arrow-right"></i>
              <span class="item-class-spandx">{{exportMenu[menuIdx[0]].children[menuIdx[1]].children[menuIdx[2]].fieldName}}
                <i class="el-icon-close iconstyle" @click="chooseCategory([menuIdx[0],menuIdx[1]])"></i>
              </span>
            </span>
          </el-col>
        <el-col class="actions" :span="3">
        </el-col>
      </el-row>
      <!-- 一级检索 -->
      <el-row class="item-class-group"  v-if="menuIdx.length===0">
        <!-- <el-col class="item-class-name" :span="2">&nbsp;</el-col> -->
        <el-col class="item-class-select" :span="21" :style="expandShow?'height: auto;':'height: 26px;'">
          <div v-for="(item, index) in exportMenu" :key="index" @click="chooseCategory([index])" :title="item.fieldName">
            <span>{{ item.fieldName }}</span>
          </div>
        </el-col>
        <el-col class="actions" :span="3">
          <el-tag type="info" v-show="exportMenu.length>5">
            <!-- <span @click="e => show(0, e)">展开</span> -->
            <span @click="expandShow=!expandShow">{{expandShow?'收起':'展开'}}</span>
          </el-tag>
        </el-col>
      </el-row>
      <!-- 二级检索 -->
      <el-row class="item-class-group"  v-if="menuIdx.length===1&&menuIdx[0]>-1&& exportMenu[menuIdx[0]]&&exportMenu[menuIdx[0]].children">
        <!-- <el-col class="item-class-name" :span="2">&nbsp;</el-col> -->
        <el-col class="item-class-select" :span="21" :style="expandShow?'height: auto;':'height: 26px;'">
          <div v-for="(item, index) in exportMenu[menuIdx[0]].children" :key="index"
            @click="chooseCategory([menuIdx[0],index])" :title="item.fieldName">
            <span>{{ item.fieldName }}</span>
          </div>
        </el-col>
        <el-col class="actions" :span="3">
          <el-tag type="info" v-show="exportMenu[menuIdx[0]].children.length>4">
            <!-- <span @click="e => show(1, e)">展开</span> -->
            <span @click="expandShow=!expandShow">{{expandShow?'收起':'展开'}}</span>
          </el-tag>
        </el-col>
      </el-row>
      <!-- 三级检索 -->
      <el-row class="item-class-group"  v-if="menuIdx.length===2&&menuIdx[0]>-1&&menuIdx[1]>-1&& exportMenu[menuIdx[0]]&&exportMenu[menuIdx[0]].children&&exportMenu[menuIdx[0]].children[menuIdx[1]]&&exportMenu[menuIdx[0]].children[menuIdx[1]].children">
        <!-- <el-col class="item-class-name" :span="2">&nbsp;</el-col> -->
        <el-col class="item-class-select" :span="21" :style="expandShow?'height: auto;':'height: 26px;'">
          <div v-for="(item, index) in exportMenu[menuIdx[0]].children[menuIdx[1]].children" :key="index"
            @click="chooseCategory([menuIdx[0],menuIdx[1],index])" :title="item.fieldName">
            <span>{{ item.fieldName }}</span>
          </div>
        </el-col>
        <el-col class="actions" :span="3">
          <el-tag type="info" v-show="exportMenu[menuIdx[0]].children[menuIdx[1]].children.length>4">
            <!-- <span @click="e => show(1, e)">展开</span> -->
            <span @click="expandShow=!expandShow">{{expandShow?'收起':'展开'}}</span>
          </el-tag>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <div class="posts-list">
        <div class="reply-header-factor" >
          <!-- <div class="reply-header-factor"> -->
           <span @click="sortHandle()"> 按发帖时间
            <i :class="sort==='desc'?'el-icon-arrow-down':'el-icon-arrow-up'"></i>
            </span>
          <!-- </div> -->
        </div>
        <div v-if="showExportList && showExportList.length">
          <div class="posts" v-for="item in showExportList" :key="item.id">
            <div class="export">
              <img :src="item.expertAvatarUrl || BASE_URL + 'img/zwt.png'" width="162px" height="150px" :alt="item.expertName"/>
              <div class="export-name">{{item.expertName}}&nbsp;专家</div>
              <div class="export-category overell" v-if="item.fileVideoTypeAttributeEntityList">
                <span v-for="(itemLabel, indexLabel) in item.fileVideoTypeAttributeEntityList" :key="indexLabel">
                  {{itemLabel.typeAttributeValue}}
                </span>
              </div>
              <div class="export-ask" @click="routerHandleAskExport(item.expertId, item.expertName)">我要提问</div>
            </div>
            <div class="posts-info" @click="postsDetail(item.id)">
              <div class="posts-title">{{item.articleTitle}}</div>
              <div class="posts-content">{{item.articleContent}}</div>
              <div class="posts-author">
                <img :src="item.userAvatarUrl || BASE_URL + 'img/zwt.png'" width="30px" height="30px" :alt="item.postsName"/>
                <span>{{item.postsName}}&nbsp;上传&nbsp;|</span>
                <span>{{item.articleCommentCount||0}}&nbsp;个回复&nbsp;|</span>
                <span>{{item.articleViewCount||0}}&nbsp;次游览&nbsp;|</span>
                <span>&nbsp;{{item.createTime}}&nbsp;</span>
              </div>
              <div class="posts-export-reply" v-if="item.expertUserRepliyPostVo">
                <div class="posts-export-reply-title">专家答复：</div>
                <div class="posts-export-reply-content">{{item.expertUserRepliyPostVo.repliyPostContent}}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="text-align:center" v-else>
          <img :src="BASE_URL + 'img/kong.png'" alt="暂无相关数据">
        </div>
      </div>
        <!-- 分页 -->
        <!--  v-if="exportList === null || exportList.length !== 0" -->
        <div class="doclist-pagination">
          <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
          <div class="doclist-omit">{{lastOmit}}</div>
          <ul>
            <li :class="item === currentPage?'pageactive':''" v-for="(item, index) in pageList" :key="index" @click="clickPageTo(item)">{{item}}</li>
          </ul>
          <div class="doclist-omit">{{nextOmit}}</div>
          <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
          <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
          <div class="doclist-jump" @click="jumpFarPage">确定</div>
        </div>
    </div>
  </div>
</template>
<script>
import { expertPutQuestionsTo } from '@/utils/eventTracking'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      // 分页
      currentPage: 1, // 当前页
      totalPage: 1, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1],
      jumpTargetPage: 1, // 跳转页
      exportMenu: [], // 类目树
      menuIdx: [], // 类目牵引
      initFlag: true, // 初次索引
      cateIds: [],
      showExportList: [], // 显示的帖子
      exportAllList: [], // 所有帖子
      exportList: [],
      sort: 'desc',
      expandShow: false
    }
  },
  computed: {
    // showExportList () {
    //     if (this.exportList.length && this.currentPage > 0) {
    //         return this.exportList.slice((this.currentPage - 1) * 6, this.currentPage * 6)
    //     } else {
    //         return []
    //     }
    // },
    // totalPage () {
    //     return Math.ceil(this.exportList.length / 6)
    // },
    categoryIds () {
      let ids = []
      if (this.$route.query.categoryIds) {
        if (Array.isArray(this.$route.query.categoryIds)) {
          ids = this.$route.query.categoryIds
        } else {
          ids = [this.$route.query.categoryIds]
        }
      }
      return ids
    }
  },
  watch: {
    $route: {
      handler: (val, oldVal) => {
        // console.log(val);
        // this.getPostsCategoryList()
      },
      // 深度观察监听
      deep: true
    },
    '$route.query': {
      handler: 'routerWatchFun'
    }
  },
  methods: {
    routerWatchFun () {
      this.getPostsByIdPage()
    },
    routerPush (params = {}) {
      let query = {
        page: 1,
        limit: 10,
        sort: this.$route.query.sort,
        categoryIds: this.$route.query.categoryIds,
        names: this.$route.query.names,
        ...params,
      }
      this.$router.push({
        name: 'categoryArticle',
        query: query
      })
    },
    show (index, e) {
      let oEvevt = e || event
      let selects = document.getElementsByClassName('item-class-select')
      if (oEvevt.target.innerText === '展开') {
        oEvevt.target.innerText = '收起'
      } else {
        oEvevt.target.innerText = '展开'
      }
      selects[index].style.height === 'auto' ? selects[index].style.height = '' : selects[index].style.height = 'auto'
    },
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
        this.routerPush({
          page: newCurrent,
        })
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
        this.routerPush({
          page: newCurrent,
        })
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    clickPageTo (newCurrent) {
      this.changePageTo(newCurrent)
      this.routerPush({
        page: newCurrent
      })
    },
    //   第几页
    changePageTo (page) {
      this.setPostsPage(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    routerHandleAskExport (id, name) {
      expertPutQuestionsTo(name)
      this.$router.push({
        name: 'askToExpert',
        query: {
          id: id
        }
      })
    },
    postsDetail (postsId) {
      this.$router.push({
        name: 'postsDetail',
        query: {
          id: postsId
        }
      })
    },
    sortHandle () {
      this.sort = this.sort === 'desc' ? 'asc' : 'desc'
      // this.getPostsByIdPage(1)
      this.changePageTo(1)
      this.routerPush({
        sort: this.sort,
        page: 1
      })
    },
    // 获取领域所有树列表
    getExpertfield () {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertfieldrepliy/findAllExpertByFieldType`)
        .then(({ data }) => {
          if (this.$route.query.searchJson) {
            return
          }
          this.menuIdx = []
          let exportMenu = []
          if (data && data.code === 0) {
            exportMenu = data.data || []
          }
          let allList = []
          exportMenu.forEach(element => {
            let twoList = []
            if (element.children && element.children.length) {
              element.children.forEach(ele => {
                let threeList = []
                if (ele.children && ele.children.length) {
                  ele.children.forEach(item => {
                    if (item.expertFieldRepliyVoList && item.expertFieldRepliyVoList.length) {
                      allList.push(...item.expertFieldRepliyVoList)
                      threeList.push(...item.expertFieldRepliyVoList)
                      twoList.push(...item.expertFieldRepliyVoList)
                    }
                  })
                }
                ele.expertFieldRepliyVoList = threeList
              })
            }
            element.expertFieldRepliyVoList = twoList
          })
          this.exportAllList = allList
          this.exportMenu = exportMenu
          this.exportList = allList
          this.changePageTo(1)
          // console.log(exportMenu)
        })
    },
    //  更改专家类目
    chooseCategory (inds) {
      let categoryIds = []
      let expandShow = false
      if (inds.length === 0) {
        // 显示所有专家
        // this.exportList = this.exportAllList
        expandShow = this.exportMenu.length > 5
      } else if (inds.length === 1) {
        categoryIds.push(this.exportMenu[inds[0]].id + '')
        // 一级下所有专家
        // this.exportList = this.exportMenu[inds[0]].expertFieldRepliyVoList
        expandShow = this.exportMenu[inds[0]].children && this.exportMenu[inds[0]].children.length > 5
      } else if (inds.length === 2) {
        categoryIds.push(this.exportMenu[inds[0]].id + '')
        categoryIds.push(this.exportMenu[inds[0]].children[inds[1]].id + '')
        // 二级下所有专家
        // this.exportList = this.exportMenu[inds[0]].children[inds[1]].expertFieldRepliyVoList
        expandShow = this.exportMenu[inds[0]].children[inds[1]].children && this.exportMenu[inds[0]].children[inds[1]].children.length > 5
      } else if (inds.length === 3) {
        categoryIds.push(this.exportMenu[inds[0]].id + '')
        categoryIds.push(this.exportMenu[inds[0]].children[inds[1]].id + '')
        categoryIds.push(this.exportMenu[inds[0]].children[inds[1]].children[inds[2]].id + '')
        // 三级下所有专家
        // this.exportList = this.exportMenu[inds[0]].children[inds[1]].children[inds[2]].expertFieldRepliyVoList || []
        expandShow = this.exportMenu[inds[0]].children[inds[1]].children[inds[2]].children && this.exportMenu[inds[0]].children[inds[1]].children[inds[2]].children.length > 5
      }
      this.menuIdx = inds
      this.cateIds = categoryIds
      this.currentPage = 1
      this.expandShow = !expandShow
      let searchJson = {
        categoryIds: this.categoryIds,
        menuIdx: this.menuIdx,
        expandShow: this.expandShow,
        exportMenu: this.exportMenu
      }
      this.changePageTo(1)
      this.routerPush({
        page: 1,
        typeId: this.cateIds[this.cateIds.length - 1],
        searchJson: JSON.stringify(searchJson)
      })
    },
    // 获取所有帖子类目
    getPostsCategoryList () {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertfieldtype/findDataByTree`)
        .then(({ data }) => {
          if (this.$route.query.searchJson) {
            return
          }
          let exportMenu = []
          let menuIdx = []
          if (data && data.code === 0) {
            exportMenu = data.data || []
            if (this.categoryIds.length > 0) {
              let oneIndex = exportMenu.findIndex(item => {
                return (item.id + '') === (this.categoryIds[0] + '')
              })
              if (oneIndex > -1) {
                menuIdx.push(oneIndex)
                if (this.categoryIds.length > 1) {
                  let twoIndex = exportMenu[oneIndex].children.findIndex(item => {
                    return (item.id + '') === (this.categoryIds[1] + '')
                  })
                  if (twoIndex > -1) {
                    menuIdx.push(twoIndex)
                  }
                }
              }
            }
          }
          // console.log(menuIdx, this.categoryIds)
          this.cateIds = this.categoryIds
          this.menuIdx = menuIdx
          this.exportMenu = exportMenu
        })
    },
    // 获取对应类目下的分页帖子列表
    getPostsByIdPage (currentPage = this.currentPage) {
      let params = {}
      if (this.$route.query.page) {
        params = {
          ...this.$route.query,
          page: Number(this.$route.query.page),
          limit: Number(this.$route.query.limit)
        }
      } else {
        params = {
          page: 1,
          limit: 10,
          order: 'desc',
          typeId: null
        }
      }
      // let searchId = ''
      // if (this.cateIds.length > 0) {
      //   searchId = this.cateIds[this.cateIds.length - 1]
      // }
      // console.log(this.cateIds, searchId)
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertuserarticle/findArticlesByTypeId`, params)
        .then(({ data }) => {
          let showExportList = []
          let count = 0
          if (data && data.code === 0) {
            showExportList = data.data.data || []
            count = data.data.count || 0
          }
          this.totalPage = Math.ceil(count / 10)
          this.showExportList = showExportList
          this.setPostsPage(params.page)
        })
    },
    setPostsPage (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          if (newPageList[newPageList.length - 1] < this.totalPage) {
            this.nextOmit = '...'
          } else {
            this.nextOmit = ''
          }
          if (newPageList[0] > 1) {
            this.lastOmit = '...'
          } else {
            this.lastOmit = ''
          }
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.currentPage = page
        this.lastOmit = ''
        this.nextOmit = ''
      }
    }
  },
  mounted () {
    if (this.$route.query.page) {
      let chooseExpertQuery = this.$route.query
      this.currentPage = chooseExpertQuery.page
      this.sort = chooseExpertQuery.order
      if (chooseExpertQuery.searchJson) {
        let chooseExpertSearch = JSON.parse(chooseExpertQuery.searchJson)
        this.categoryIds = chooseExpertSearch.categoryIds
        this.menuIdx = chooseExpertSearch.menuIdx
        this.expandShow = chooseExpertSearch.expandShow
        this.exportMenu = chooseExpertSearch.exportMenu
      }
    }
    // this.getExpertfield()
    this.getPostsCategoryList()
    this.cateIds = this.categoryIds
    this.getPostsByIdPage(1)
  }
}
</script>
<style scoped>
  .container{
    width:100%;
    background-color: #ffffff;
  }
  .yjlm{
    line-height: 40px;
    color: #333;
    border-right: 2px #eee solid;
    padding: 0px 20px;
    height: 40px;
    width: auto;
    display: table;
    float: left;
  }
  .yjlm:hover{
    background: #1D65A8;
    color: #ffffff;
    cursor: pointer;
  }
  .posts-list{
    padding: 30px;
  }
  /* 帖子信息 */
  .posts{
    padding: 30px 0;
    display: flex;
    border-bottom: 2px solid #eee;
  }
  /* 专家信息 */
  .export{
    width: 162px;
    text-align: center;

  }
  .export-name{
    line-height: 22px;
    font-size: 16px;
    color: #262626;
    height: 22px;
    margin-top: 14px;
    margin-bottom: 6px;
  }
  .export-category{
    width: 100%;
    line-height: 20px;
    font-size: 14px;
    color: #666666;
    height: 20px;
    margin-bottom: 14px;
    overflow: hidden;
  }
  .export-category span{
    margin-right: 5px;
  }
  .export-ask{
    border: 1px solid #1D65A8;
    width: 96px;
    height: 32px;
    line-height: 30px;
    margin: 0  auto;
    cursor: pointer;
  }
  .export-ask:hover{
    background-color: #1D65A8;
    color: #fff;
  }
  /* 帖子信息 */
  .posts-info{
    width: 668px;
    padding-left: 20px;
    cursor: pointer;
    overflow: hidden;
  }
  .posts-title{
    width: 100%;
    text-align: left;
    line-height: 22px;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    height: 22px;
    margin-bottom: 8px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  .posts-content{
    width: 100%;
    text-align: left;
    line-height: 22px;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0.4px;
    margin-bottom: 10px;
    height: 66px;
    overflow:hidden;
    word-break:break-all;
    white-space:pre-wrap;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
  .posts-author{
    height: 59px;
    line-height: 30px;
    text-align: left;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0.7px;
    border-bottom: 1px solid #eee;
    padding-bottom: 28px;
  }
  .posts-author img{
    height: 30px;
    width: 30px;
    border-radius: 15px;
    overflow: hidden;
    margin-right: 10px;
  }
  /* 帖子专家回复 */
  .posts-export-reply{
    margin-top: 30px;
  }
  .posts-export-reply-title{
    line-height: 20px;
    font-size: 14px;
    color: #E99436;
    letter-spacing: 0.4px;
    height: 20px;
    margin-bottom: 10px;
  }
  .posts-export-reply-content{
    font-size: 14px;
    color: #666666;
    letter-spacing: 0.4px;
    line-height: 22px;
    height: 66px;
    overflow:hidden;
    word-break:break-all;
    white-space:pre-wrap;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
/* 分页区域样式 */
.doclist-pagination .pageactive{
  background: #1D65A8;
  color: #ffffff;
}
.doclist-pagination{
  display: flex;
  height: 40px;
  line-height: 40px;
  text-align: center;
  /* padding-left: 95px; */
}
.doclist-pagination ul{
  display: flex;
}
.doclist-pagination ul li{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.doclist-omit{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage{
  font-size: 14px;
  color: #666666;
}
.doclist-nextpage{
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
}
.doclist-pagejump{
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input{
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
}
.doclist-jump{
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
}
.doclist-lastpage{
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage{
  user-select: none;
  cursor: pointer;
}
/* 分页区域样式结束 */
.reply-header-factor{
    width: 100%;
    text-align: right;
    line-height: 20px;
    font-size: 14px;
    color: #1D65A8;
    letter-spacing: 0.52px;
    height: 20px;
}
.reply-header-factor span{
  cursor: pointer;
}
</style>
